import { setTokens, store } from "@redux"

const saveTokensInLocaleStorage = async (at, rt = "") => {
  localStorage.setItem("at", at)
  localStorage.setItem("rt", rt)


  store.dispatch(
    setTokens({
      accessToken: at,
      refreshToken: rt
    })
  )
}

export default saveTokensInLocaleStorage